import React from 'react';
import { useSelector } from 'react-redux';
import Permission from 'spark-util/Permission';
import { getTimeSince } from 'spark-util/dateUtils';
import SplitToolbar from 'spark-ui/ui-kitchen/utensils/SplitToolbar';
import { getLastCtmsRefreshDate } from 'spark-state/enterprise/enterpriseReducer';
import { SHELL_FOOTER_STACK_OFFSET } from 'spark-views/common/header/navigationBarConfig';
import styled from 'styled-components';

const RefreshIndicatorBar = styled.footer`
box-sizing: border-box;
position: absolute;
bottom: 0;
width: 100%;

margin-bottom: ${SHELL_FOOTER_STACK_OFFSET}px;
font-size: 14px;
text-align: left;
    & a {
        color: #0768FD;
        text-decoration: none;
        display: inline-block;
        margin-bottom: 0.2em;
    }

    & .ctmsRefresh {
        font-size: 1.2em;
    }
`;

/**created this Component to display the CTMS refresh indicator on the Safety App. 
 * Seprated from Footer.js as the footer has to be same across all the applications as part of IQVIA rebranding (SAF-13902) */

const CtmsRefreshIndicator = () => {
    const lastRefreshDate = useSelector(getLastCtmsRefreshDate);
    const timeSinceRefresh = lastRefreshDate && getTimeSince(lastRefreshDate);

    return (
        <RefreshIndicatorBar>   
            <SplitToolbar> 
                <div></div>
                <div>
                    <Permission requires="ctms.displayCTMSRefreshIndicator">
                        <CTMSRefreshIndicator timeSinceRefresh={timeSinceRefresh} />
                    </Permission>
                </div>
                <div></div>
            </SplitToolbar>
        </RefreshIndicatorBar>
    );
};

const CTMSRefreshIndicator = ({ timeSinceRefresh }) =>
    timeSinceRefresh && (
        <div>{`${timeSinceRefresh} since last CTMS refresh`}</div>
    );

export default CtmsRefreshIndicator;
